import { Card } from '@zorro/design-system/v2/Card';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { Link } from '@zorro/design-system/v2/Link';
import { Title } from '@zorro/design-system/v2/Title';
import { ZorroQuestionmarkIcon } from '@zorro/shared/assets';
import { Box, Group, Stack } from '@zorro/web/design-system';
import React, { ReactNode, useState } from 'react';

import { FormFooter } from '../../FormFooter';

type LinkData = {
  name: string;
  href: string;
  isDrawer: boolean;
};

type Props = {
  links: LinkData[];
  children?: ReactNode;
};

const FaqSection = ({ links, children }: Props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <Card variant="white-border" bd="1px solid zorroGray.2" miw="15rem" p="sm">
      <Stack gap="xs">
        <Group gap="xxs" wrap="nowrap">
          <ZorroQuestionmarkIcon />
          <Title order={4}>FAQs</Title>
        </Group>

        <Stack gap="xxs">
          {links.map((link: LinkData, idx) => (
            <Box key={link.name}>
              {link.isDrawer ? (
                <Link
                  href={`#show_faq_${idx + 1}`}
                  onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                    event.preventDefault();
                    setIsDrawerOpen(true);
                  }}
                >
                  {link.name}
                </Link>
              ) : (
                <Link href={link.href} target="_blank">
                  {link.name}
                </Link>
              )}
            </Box>
          ))}
        </Stack>
      </Stack>

      <Drawer
        onClose={() => setIsDrawerOpen(false)}
        title="Frequently asked questions"
        position="right"
        opened={isDrawerOpen}
        footer={
          <FormFooter
            withPaper={false}
            primaryLabel="Close"
            primaryButtonProps={{ onClick: () => setIsDrawerOpen(false) }}
          />
        }
      >
        {children}
      </Drawer>
    </Card>
  );
};

export default FaqSection;
